// Datos del Footer, agrupados por sección y por país.
//
// Cada país solo declara las secciones ("servicioCliente", "newsletter",
// "redesSociales") de las que ya tiene información real. Footer.js decide
// qué renderizar únicamente en base a qué claves existen aquí — nunca
// según el código de país — así que:
//   - agregar un país nuevo es agregar una entrada en este objeto.
//   - agregar una sección a un país existente (ej. "servicioCliente" a CR)
//     hace que esa sección aparezca sola, sin tocar Footer.js.

const FOOTER_DATOS_POR_PAIS = {
  GT: {
    servicioCliente: {
      web: { url: "https://www.somit.com/", texto: "www.somit.com" },
      telefonos: [
        { etiqueta: "Cabina 24/7", numero: "(502)23868310", tel: "+50223868310" },
      ],
      correo: { direccion: "contactenosgt@somit.com" },
      cotizar: { url: "https://www.somit.com/cotizadores/" },
    },
    newsletter: {
      texto: "Recibe información de nuestras últimas novedades en productos y asesoria",
    },
    redesSociales: [
      { tipo: "instagram", usuario: "@somit_corredores_de_seguros", url: "https://instagram.com/somit_corredores_de_seguros" },
      { tipo: "facebook", usuario: "somit_corredores_de_seguros", url: "https://www.facebook.com/somitseguros/" },
      { tipo: "linkedin", usuario: "somit_corredores_de_seguros", url: "https://www.linkedin.com/company/somit-corredores-de-seguros/mycompany/" },
      { tipo: "whatsapp", usuario: "(502) 22856501", url: "https://wa.me/50222856501" },
    ],
  },

  CR: {
    // Aún no hay datos propios de "Servicio al Cliente" ni "Newsletter"
    // para Costa Rica. Cuando existan, agregar aquí las claves
    // "servicioCliente" y/o "newsletter" (mismo formato que en GT) y esas
    // secciones se mostrarán automáticamente junto a Redes Sociales.
    //
    // "contactenosApi" activa la carga en vivo desde el backend
    // (getParametrosGeneralesAPP/CONTACTENOS?pais=<idPais>-<codigoAseguradora>).
    // idPais=3 y codigoAseguradora=214 son los valores fijos/públicos de
    // Costa Rica, usados SOLO mientras no hay sesión (Guatemala es
    // idPais=1, sin código de aseguradora).
    //
    // Dos comportamientos distintos con el mismo dato, según haya sesión:
    //   - Sin sesión (visitante anónimo): solo se muestran "web" y
    //     "redesSociales" → diseño "destacado" (antes del login no se sabe
    //     la aseguradora real del visitante, aunque el código público 214
    //     ya tenga cabina/correo cargados).
    //   - Con sesión y póliza seleccionada (AseguradoraContext trae el
    //     código real de esa póliza): se arma también "servicioCliente"
    //     (cabina/correo) → el footer pasa automáticamente a la grilla
    //     completa (ver Footer.js: useDatosFooter + contactenosParaFooter.js).
    // Si el backend no tiene datos para la combinación pedida, se usa el
    // resto de esta entrada como fallback estático (solo redes + web).
    contactenosApi: { idPais: "3", codigoAseguradora: "214" },
    web: { url: "https://www.somit.com/", texto: "www.somit.com" },
    mensajeRedesSociales: "Conéctate con SOMIT a través de nuestras redes sociales",
    redesSociales: [
      { tipo: "instagram", usuario: "@somit_corredores_de_seguros", url: "https://instagram.com/somit_corredores_de_seguros" },
      { tipo: "facebook", usuario: "somit_corredores_de_seguros", url: "https://www.facebook.com/somitseguros/" },
      { tipo: "linkedin", usuario: "somit_corredores_de_seguros", url: "https://www.linkedin.com/company/somit-corredores-de-seguros/mycompany/" },
      // Falta el WhatsApp específico de Costa Rica: agregar aquí
      // { tipo: "whatsapp", usuario: "...", url: "https://wa.me/506..." } cuando se tenga el número.
    ],
  },
};

export default FOOTER_DATOS_POR_PAIS;
